import { render } from "./ReviewTypeSelectionModal.vue?vue&type=template&id=6d3d33bc&scoped=true"
import script from "./ReviewTypeSelectionModal.vue?vue&type=script&lang=js"
export * from "./ReviewTypeSelectionModal.vue?vue&type=script&lang=js"

import "./ReviewTypeSelectionModal.vue?vue&type=style&index=0&id=6d3d33bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3d33bc"]])

export default __exports__